import { useI18n } from "vue-i18n";

export const n = (number, type, compiler = useI18n().n) => {
  const floatNumber = Number.parseFloat(number);
  if (Number.isNaN(floatNumber)) return "";
  return compiler(floatNumber, type).replace(/CAD\s/g, "$");
};

export default { n };
